import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import { NotificationManager } from "react-notifications";
import MainService from "../../Common/MainService";
import "./ViewAssetDistributersComponent.css";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import SearchBar from "material-ui-search-bar";
import ListIcon from "@material-ui/icons/List";
import GridIcon from "@material-ui/icons/GridOnOutlined";
import MapIcon from "@material-ui/icons/MapRounded";
import CircularProgress from "@material-ui/core/CircularProgress";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
  MarkerClusterer,
} from "@react-google-maps/api";



const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
    //maxWidth: 350,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  uploadButton: {
    margin: theme.spacing(1),
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 10,
    color: "#fff",
  },
}));

export default function ViewAssetDistributersComponent(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [assetDistributorsList, setAssetDistributorsList] = useState([]);
  const [assetDistributorUserId, setAssetDistributorUserId] = useState("");
  const [assetDistributorUserName, setAssetDistributorUserName] = useState("");
  const [assetDistributorAddress, setAssetDistributorAddress] = useState("");
  const [assetDistributorCity, setAssetDistributorCity] = useState("");
  const [assetDistributorFirstName, setAssetDistributorFirstName] =
    useState("");
  const [assetDistributorLastName, setAssetDistributorLastName] = useState("");
  const [assetDistributorPhone, setAssetDistributorPhone] = useState("");
  const [assetDistributorEnterpriceId, setAssetDistributorEnterpriceId] =
    useState("");
  const [assetDistributorUserType, setAssetDistributorUserType] = useState("");
  const [assetDistributorEmail, setAssetDistributorEmail] = useState("");
  const [assetDistributorDomain, setAssetDistributorDomain] = useState("");
  const [assetDistributorState, setAssetDistributorState] = useState("");
  const [assetDistributorNominee, setAssetDistributorNominee] = useState("");
  const [assetDistributorPancard, setAssetDistributorPancard] = useState("");
  const [assetDistributorLongitude, setAssetDistributorLongitude] =
    useState("");
  const [assetDistributorLatitude, setAssetDistributorLatitude] = useState("");
  const [assetDistributorMessage, setAssetDistributorMessage] = useState("");
  const [assetDistributorStatus, setAssetDistributorStatus] = useState("");
  const { user } = MainService.getLocalData();
  const { username } = user;
  const [assetDistributorInfoDialog, setAssetDistributorInfoDialog] =
    React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [emailValue, setEmailValue] = React.useState("");
  const [messageValue, setMessageValue] = React.useState("");
  const [assetDistributorEmailDialog, setAssetDistributorEmailDialog] =
    React.useState(false);
  const [subjectValue, setSubjectValue] = React.useState("");
  const [assetDistributorSMSDialog, setAssetDistributorSMSDialog] =
    React.useState(false);
  const [phoneNumerValue, setPhoneNumerValue] = React.useState("");
  const [
    selectedAssetDistributorUsername,
    setSelectedAssetDistributorUserName,
  ] = useState("");
  const [filteredAssetDistributors, setFilteredAssetDistributors] = useState(
    []
  );
  const [searched, setSearched] = useState("");
  const [listView, setListView] = useState(true);
  const [gridView, setGridView] = useState(false);
  const [mapView, setMapView] = useState(false);
  const [viewAllClick, setViewAllClick] = useState(true);
  const [viewAssociatedClick, setViewAssociatedClick] = useState(false);

 
  useEffect(() => {
    getAllAssetDistributos();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  /* View All  */
  const getAllAssetDistributos = () => {
    MainService.getAssetDistributors()
      .then((res) => {
        setAssetDistributorsList(res);
        setFilteredAssetDistributors(res);
      })
      .catch((err) => {
        return NotificationManager.error(err);
      });
  };
  /* End All  */

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClose = () => {};
  /* Logistic Provider info Dialog */
  const assetDistributorViewInfoDialogClick = (assetDistributor) => {
    MainService.getLogisticProviderInfo(assetDistributor)
      .then((res) => {
        setAssetDistributorUserId(res[0].userid);
        setAssetDistributorUserName(res[0].username);
        setAssetDistributorFirstName(res[0].firstname);
        setAssetDistributorLastName(res[0].lastname);
        setAssetDistributorEnterpriceId(res[0].enterpriseid);
        setAssetDistributorUserType(res[0].usertype);
        setAssetDistributorEmail(res[0].email);
        setAssetDistributorDomain(res[0].domain);
        setAssetDistributorPhone(res[0].phone);
        setAssetDistributorAddress(res[0].address);
        setAssetDistributorCity(res[0].city);
        setAssetDistributorState(res[0].state);
        setAssetDistributorNominee(res[0].nominee);
        setAssetDistributorPancard(res[0].pancard);
        setAssetDistributorLongitude(res[0].longitude);
        setAssetDistributorLatitude(res[0].latitude);
        setAssetDistributorMessage(res[0].message);
        setAssetDistributorStatus(res[0].status);
      })
      .catch((err) => {
        return NotificationManager.error(err);
      });
    setAssetDistributorInfoDialog(!assetDistributorInfoDialog);
  };

  const assetDistributorSendEmailClick = (selectedUser) => {
    setSelectedAssetDistributorUserName(selectedUser);
    setAssetDistributorEmailDialog(!assetDistributorEmailDialog);
  };
  const sendEmailClick = () => {
    let emailData = {
      subject: subjectValue,
      content: messageValue,
    };
    const emailDataString = JSON.stringify(emailData);
    MainService.sendEmail(emailValue, emailDataString)
      .then((res) => {
        return NotificationManager.success("email Sent Successfully");
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
    setAssetDistributorEmailDialog(!assetDistributorEmailDialog);
  };

  const sendSMSClick = () => {
    let smsData = {
      sms: messageValue,
    };
    const smsDataString = JSON.stringify(smsData);
    MainService.sendSMS(phoneNumerValue, smsDataString)
      .then((res) => {
        return NotificationManager.success("Message Sent Successfully");
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
    setAssetDistributorSMSDialog(!assetDistributorSMSDialog);
  };

  const assetDistributorSendMessageClick = (selectedUser) => {
    setSelectedAssetDistributorUserName(selectedUser);
    setAssetDistributorSMSDialog(!assetDistributorSMSDialog);
  };

  
  const requestSearch = (searchedVal) => {
    const filteredRows = filteredAssetDistributors.filter((row) => {
      return row.username.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setAssetDistributorsList(filteredRows);
  };
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const listViewClick = () => {
    setListView(true);
    setGridView(false);
    setMapView(false);
  };
  const gridViewClick = () => {
    setListView(false);
    setGridView(true);
    setMapView(false);
  };
  const mapViewClick = () => {
    setListView(false);
    setGridView(false);
    setMapView(true);
  };

  const AssociatedAssetDistributorsClick = () => {
    setViewAllClick(false);
    setViewAssociatedClick(true);
  };
  const AllAssetDistributorsClick = () => {
    setViewAllClick(true);
    setViewAssociatedClick(false);
  };

  
  /* new map1 */
  const [selected, setSelected] = useState({});
  const options = {
    imagePath:
      "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
  };
  const onSelect = (item) => {
    setSelected(item);
  };
  const mapStyles = {
    height: "100vh",
    width: "100%",
  };

  const defaultCenter = {
    lat: 13.093426,
    lng: 77.655773,
  };
  return (
    <>
      <div className="container" id="mainContentList">
        <div style={{ float: "right" }}>
          <Button
            startIcon={<ListIcon />}
            size="large"
            onClick={listViewClick}
          ></Button>
          <Button
            startIcon={<GridIcon />}
            size="large"
            onClick={gridViewClick}
          ></Button>
          <Button
            startIcon={<MapIcon />}
            size="large"
            onClick={mapViewClick}
          ></Button>
          &nbsp;
          {viewAllClick && (
            <Button
              color="primary"
              className="registerBtn"
              variant="contained"
              onClick={AssociatedAssetDistributorsClick}
            >
              View Associated Asset Distributors
            </Button>
          )}
          {viewAssociatedClick && (
            <Button
              color="primary"
              className="registerBtn"
              variant="contained"
              onClick={AllAssetDistributorsClick}
            >
              View All Asset Distributors
            </Button>
          )}
        </div>
        {viewAllClick && (
          <div>
            <h2>View Asset Distributors(Broker)</h2>
            {listView && (
              <Paper sx={{ width: "100%" }}>
                <SearchBar
                  value={searched}
                  onChange={(searchVal) => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                />
                <TableContainer sx={{ maxHeight: 440 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow align="center">
                        <TableCell align="center" colSpan={12}>
                          List of Asset Distributors
                        </TableCell>
                      </TableRow>
                      <TableRow align="center">
                        <TableCell align="center" colSpan={1}>
                          User Id
                        </TableCell>
                        <TableCell align="center" colSpan={1}>
                          User Name
                        </TableCell>
                        <TableCell align="center" colSpan={1}>
                          View
                        </TableCell>
                        <TableCell align="center" colSpan={1}>
                          Operate
                        </TableCell>
                        <TableCell align="center" colSpan={3}>
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {assetDistributorsList.length > 0 ? (
                        assetDistributorsList
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((assetDistributors, index) => {
                            return (
                              <TableRow hover tabIndex={-1} key={index}>
                                <TableCell align="center">
                                  {assetDistributors.userid}
                                </TableCell>
                                <TableCell align="center">
                                  {assetDistributors.username}
                                </TableCell>

                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorViewInfoDialogClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    View Info
                                  </Button>
                                </TableCell>
                                <TableCell align="center"></TableCell>

                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendMessageClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Message
                                  </Button>
                                </TableCell>
                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendEmailClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Email
                                  </Button>
                                </TableCell>
                                
                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    /* onClick={() => {
                                    assetDistributorSendFeedbackClick(
                                      assetDistributors.userid
                                    );
                                  }} */
                                  >
                                    Feedback
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })
                      ) : (
                        <TableRow align="center">
                          <TableCell align="center" colSpan={12}>
                            Asset Distributors Not Found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={assetDistributorsList.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            )}
            {gridView && (
              <div className="cardStyleForDashboardItems">
                {isLoading ? (
                  <div className="cardStyleForDashboardItems">
                    <CircularProgress />
                  </div>
                ) : (
                  <div className="cardStyleForDashboardItems">
                    {assetDistributorsList.length > 0 ? (
                      <div className="cardStyleForDashboardItems">
                        {assetDistributorsList.map(
                          (assetDistributors, index) => (
                            <div
                              key={index}
                              className="cardStyleForDashboardItemsBody"
                            >
                              <span>
                                <p>
                                  <b>User Id:</b>
                                  {assetDistributors.userid}
                                </p>
                              </span>
                              <p>
                                <b>User Name:</b>
                                {assetDistributors.username}
                              </p>
                              <h4 className="cardactiontitle">View</h4>
                              <div>
                                <Button
                                  type="button"
                                  variant="contained"
                                  onClick={() => {
                                    assetDistributorViewInfoDialogClick(
                                      assetDistributors.username
                                    );
                                  }}
                                >
                                  View Info
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                              <div>
                                <h4 className="cardactiontitle">Operate</h4>
                              </div>
                              <div>
                                <h4 className="cardactiontitle">Actions</h4>
                                <div>
                                  <Button
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendEmailClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Email
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendMessageClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Msssage
                                  </Button>
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  
                                  <Button type="button" variant="contained">
                                    Feedback
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    ) : (
                      <h4>Asset Distributors not found.</h4>
                    )}
                  </div>
                )}
              </div>
            )}
            {mapView && (
              <div>
                <LoadScript googleMapsApiKey="AIzaSyDzJglX1KEZkksRUr_zBWrHAG3ZYeUZt4o">
                  <GoogleMap
                    mapContainerStyle={mapStyles}
                    zoom={4}
                    center={defaultCenter}
                  >
                    <MarkerClusterer options={options} averageCenter={true}>
                      {(clusterer) =>
                        assetDistributorsList.map((markerObj, index) => {
                          return (
                            <Marker
                              key={index}
                              position={{
                                lat: parseFloat(markerObj.latitude),
                                lng: parseFloat(markerObj.longitude),
                              }}
                              clusterer={clusterer}
                              onClick={() => onSelect(markerObj)}
                            />
                          );
                        })
                      }
                    </MarkerClusterer>

                    {selected.latitude && selected.longitude && (
                      <InfoWindow
                        position={{
                          lat: parseFloat(selected.latitude),
                          lng: parseFloat(selected.longitude),
                        }}
                        clickable={true}
                        onCloseClick={() => setSelected({})}
                      >
                        <CardContent>
                          <Typography variant="body2" color="textSecondary">
                            <b>ID:</b> {selected.siteid}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            <b> Name:</b>Site{selected.sitename}
                          </Typography>
                        </CardContent>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            )}
          </div>
        )}
        {viewAssociatedClick && (
          <div>
            <h2>View Associated Asset Distributors(Broker)</h2>
            {listView && (
              <Paper sx={{ width: "100%" }}>
                <SearchBar
                  value={searched}
                  onChange={(searchVal) => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                />
                <TableContainer sx={{ maxHeight: 440 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow align="center">
                        <TableCell align="center" colSpan={12}>
                          List of Associated Asset Distributors
                        </TableCell>
                      </TableRow>
                      <TableRow align="center">
                        <TableCell align="center" colSpan={1}>
                          User Id
                        </TableCell>
                        <TableCell align="center" colSpan={1}>
                          User Name
                        </TableCell>
                        <TableCell align="center" colSpan={1}>
                          View
                        </TableCell>
                        <TableCell align="center" colSpan={1}>
                          Operate
                        </TableCell>
                        <TableCell align="center" colSpan={3}>
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {assetDistributorsList.length > 0 ? (
                        assetDistributorsList
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((assetDistributors, index) => {
                            return (
                              <TableRow hover tabIndex={-1} key={index}>
                                <TableCell align="center">
                                  {assetDistributors.userid}
                                </TableCell>
                                <TableCell align="center">
                                  {assetDistributors.username}
                                </TableCell>

                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorViewInfoDialogClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    View Info
                                  </Button>
                                </TableCell>

                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendMessageClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Message
                                  </Button>
                                </TableCell>
                                <TableCell align="center">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendEmailClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Email
                                  </Button>
                                </TableCell>
                                
                              </TableRow>
                            );
                          })
                      ) : (
                        <TableRow align="center">
                          <TableCell align="center" colSpan={12}>
                            Associated Asset Distributors Not Found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={assetDistributorsList.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            )}
            {gridView && (
              <div className="cardStyleForDashboardItems">
                {isLoading ? (
                  <div className="cardStyleForDashboardItems">
                    <CircularProgress />
                  </div>
                ) : (
                  <div className="cardStyleForDashboardItems">
                    {assetDistributorsList.length > 0 ? (
                      <div className="cardStyleForDashboardItems">
                        {assetDistributorsList.map(
                          (assetDistributors, index) => (
                            <div
                              key={index}
                              className="cardStyleForDashboardItemsBody"
                            >
                              <span>
                                <p>
                                  <b>User Id:</b>
                                  {assetDistributors.userid}
                                </p>
                              </span>
                              <p>
                                <b>User Name:</b>
                                {assetDistributors.username}
                              </p>

                              <h4 className="cardactiontitle">View</h4>
                              <div>
                                <Button
                                  type="button"
                                  variant="contained"
                                  onClick={() => {
                                    assetDistributorViewInfoDialogClick(
                                      assetDistributors.username
                                    );
                                  }}
                                >
                                  View Info
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                              <div>
                                <h4 className="cardactiontitle">Operate</h4>
                              </div>
                              <div>
                                <h4 className="cardactiontitle">Actions</h4>
                                <div>
                                  <Button
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendEmailClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Email
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                      assetDistributorSendMessageClick(
                                        assetDistributors.username
                                      );
                                    }}
                                  >
                                    Send Msssage
                                  </Button>
                                </div>
                                &nbsp;&nbsp;
                                <div>
                                  
                                  <Button type="button" variant="contained">
                                    Feedback
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    ) : (
                      <h4>Associated Asset Distributors not found.</h4>
                    )}
                  </div>
                )}
              </div>
            )}
            {mapView && (
              <div>
                <LoadScript googleMapsApiKey="AIzaSyDzJglX1KEZkksRUr_zBWrHAG3ZYeUZt4o">
                  <GoogleMap
                    mapContainerStyle={mapStyles}
                    zoom={4}
                    center={defaultCenter}
                  >
                    <MarkerClusterer options={options} averageCenter={true}>
                      {(clusterer) =>
                        assetDistributorsList.map((markerObj, index) => {
                          return (
                            <Marker
                              key={index}
                              position={{
                                lat: parseFloat(markerObj.latitude),
                                lng: parseFloat(markerObj.longitude),
                              }}
                              clusterer={clusterer}
                              onClick={() => onSelect(markerObj)}
                            />
                          );
                        })
                      }
                    </MarkerClusterer>

                    {selected.latitude && selected.longitude && (
                      <InfoWindow
                        position={{
                          lat: parseFloat(selected.latitude),
                          lng: parseFloat(selected.longitude),
                        }}
                        clickable={true}
                        onCloseClick={() => setSelected({})}
                      >
                        <CardContent>
                          <Typography variant="body2" color="textSecondary">
                            <b>ID:</b> {selected.siteid}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            <b> Name:</b>Site{selected.sitename}
                          </Typography>
                        </CardContent>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </LoadScript>
              </div>
            )}
          </div>
        )}
        {/* Send SMS */}
        <Dialog
          fullScreen={fullScreen}
          open={assetDistributorSMSDialog}
          onClose={handleClose}
          aria-labelledby="sendSMS"
        >
          <DialogTitle id="sendSMS">Send SMS</DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="assetDistributorUsername">
                User Name:
              </InputLabel>
              <Input
                disabled
                id="assetDistributorUsername"
                name="assetDistributorUsername"
                type="text"
                value={selectedAssetDistributorUsername}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="phone">Mobile Number:</InputLabel>
              <Input
                id="phone"
                name="phone"
                type="text"
                value={phoneNumerValue}
                onChange={(e) => {
                  setPhoneNumerValue(e.target.value);
                }}
              />
            </FormControl>

            <FormControl fullWidth={true} className="loginFields">
              <p htmlFor="messageDescription">Message:</p>
              <TextareaAutosize
                minRows={5}
                style={{ minwidth: 200 }}
                value={messageValue}
                onChange={(e) => {
                  setMessageValue(e.target.value);
                }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                sendSMSClick();
              }}
            >
              Send
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setAssetDistributorSMSDialog(!assetDistributorSMSDialog);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* Send Email */}
        <Dialog
          fullScreen={fullScreen}
          open={assetDistributorEmailDialog}
          onClose={handleClose}
          aria-labelledby="sendEmail"
        >
          <DialogTitle id="sendEmail">{"Send Email"}</DialogTitle>
          <DialogContent>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="assetDistributorUsername">
                User Name:
              </InputLabel>
              <Input
                disabled
                id="assetDistributorUsername"
                name="assetDistributorUsername"
                type="text"
                value={selectedAssetDistributorUsername}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="email">E-Mail Id:</InputLabel>
              <Input
                id="email"
                name="email"
                type="email"
                value={emailValue}
                onChange={(e) => {
                  setEmailValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <InputLabel htmlFor="subject">Subject:</InputLabel>
              <Input
                id="subject"
                name="subject"
                type="text"
                value={subjectValue}
                onChange={(e) => {
                  setSubjectValue(e.target.value);
                }}
              />
            </FormControl>
            <FormControl fullWidth={true} className="loginFields">
              <p htmlFor="messageDescription">Message:</p>
              <TextareaAutosize
                minRows={5}
                style={{ minwidth: 200 }}
                value={messageValue}
                onChange={(e) => {
                  setMessageValue(e.target.value);
                }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                sendEmailClick();
              }}
            >
              Submit
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setAssetDistributorEmailDialog(!assetDistributorEmailDialog);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* View Info */}
        <Dialog
          fullScreen={fullScreen}
          open={assetDistributorInfoDialog}
          onClose={handleClose}
          aria-labelledby="viewInfoDialog"
        >
          <DialogTitle id="viewInfoDialog">
            {"View Asset Deistributor Info"}
          </DialogTitle>
          <DialogContent>
            <p>
              <b>User Id:</b>
              {assetDistributorUserId}
            </p>
            <p>
              <b>User Name:</b>
              {assetDistributorUserName}
            </p>
            <p>
              <b>First Name:</b>
              {assetDistributorFirstName}
            </p>
            <p>
              <b>Last Name:</b>
              {assetDistributorLastName}
            </p>
            <p>
              <b>Enterprise Id:</b>
              {assetDistributorEnterpriceId}
            </p>
            <p>
              <b>UserType:</b>
              {assetDistributorUserType}
            </p>
            <p>
              <b>Email:</b>
              {assetDistributorEmail}
            </p>
            <p>
              <b>Domain:</b>
              {assetDistributorDomain}
            </p>
            <p>
              <b>Phone:</b>
              {assetDistributorPhone}
            </p>
            <p>
              <b>Address:</b>
              {assetDistributorAddress}
            </p>
            <p>
              <b>City:</b>
              {assetDistributorCity}
            </p>
            <p>
              <b>State:</b>
              {assetDistributorState}
            </p>
            <p>
              <b>Nominee:</b>
              {assetDistributorNominee}
            </p>
            <p>
              <b>Pancard:</b>
              {assetDistributorPancard}
            </p>
            <p>
              <b>Longitude:</b>
              {assetDistributorLongitude}
            </p>
            <p>
              <b>Latitude:</b>
              {assetDistributorLatitude}
            </p>
            <p>
              <b>Message:</b>
              {assetDistributorMessage}
            </p>
            <p>
              <b>Status:</b>
              {assetDistributorStatus}
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setAssetDistributorInfoDialog(!assetDistributorInfoDialog);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
         
      </div>
    </>
  );
}
